import { FiLogOut } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import React from "react";
const TopNav = () => {
  const navigate = useNavigate();
  const handleLogout = () => {
    // Remove token from local storage
    localStorage.removeItem("token");
    // Redirect to login page
    // Example using React Router's useNavigate hook:
    navigate("/login");
  };
  return (
    <div
      className="d-flex justify-content-between align-items-center px-4 py-2"
      //  style={{backgroundColor:"#f2f4f9",borderBottom:"3px solid white"}}
    >
      <div className="d-flex align-items-center gap-4">
        <img src="/logo.png" alt="Logo" style={{ height: "50px" }} />
        {/* <span>DISHA</span> */}
        {/* <span>Good Morning<br /><strong>John Doe!</strong></span> */}
      </div>
      <div className="d-flex align-items-center gap-4">
        <img src="/logo1.png" alt="Logo" style={{ height: "50px" }} />
        {/* <span>DISHA</span> */}
        {/* <span>Good Morning<br /><strong>John Doe!</strong></span> */}
      </div>

      <div className="d-flex align-items-center gap-3">
        {/* <input type="text" placeholder="Search by" className="form-control form-control-sm" style={{ width: '250px' }} />
        <i className="bi bi-bell fs-5"></i> */}
        <img
          src="/logo2.png"
          alt="logo1"
          // className="rounded-circle"
          style={{ height: "50px" }}
        />
        {/* 
        <button
          type="button"
          className="btn btn-dark"
          onClick={exportCurrentPage}
          disabled={exportLoading === 1}
        >
          {exportLoading === 1 ? (
            <>
              <Spinner size="sm" className="me-2" />
              exporting
            </>
          ) : (
            <>
              export<i className="icon-downlad ms-3"></i>
            </>
          )}
        </button> */}

        <button onClick={handleLogout}>
          <FiLogOut /> Logout
        </button>
      </div>
    </div>
  );
};

export default TopNav;
